import React, { PropsWithChildren } from 'react'
import { ClassicTab as ClassicTabStyled, ClassicCorner } from './SwitchTabsStyled'

const ClassicTab = ({
  children,
  ...props
}: PropsWithChildren<{
  'data-id': number | string
  activated?: boolean
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}>) => (
  <ClassicTabStyled {...props}>
    <ClassicCorner />
    {children}
    <ClassicCorner />
  </ClassicTabStyled>
)

export default ClassicTab
